import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/whatsapp';

const { FiArrowUpRight } = FiIcons;
const coaches = [
  { img: 'https://images.unsplash.com/photo-1567013127542-490d757e51fc?auto=format&fit=crop&w=900&q=85', tag: 'STRENGTH & CONDITIONING', name: 'Alex Morgan', role: 'Head Coach' },
  { img: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=900&q=85', tag: 'MOBILITY & RECOVERY', name: 'Jordan Lee', role: 'Movement Coach' },
  { img: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=900&q=85', tag: 'ENGINE & ENDURANCE', name: 'Sam Rivera', role: 'Performance Coach' },
];

function Coaches() {
  return (
    <section className="coaches-section" id="coaches">
      <div className="section-head">
        <div>
          <span className="eyebrow">People make the place</span>
          <h2>Good energy.<br /><em>Great coaching.</em></h2>
        </div>
        <p>Real coaches who pay attention, know your name, and know when you have more in the tank.</p>
      </div>
      <div className="coach-grid">
        {coaches.map((c, i) => (
          <motion.a
            href={waLink(`I would like to train with ${c.name}.`)}
            target="_blank"
            rel="noreferrer"
            className="coach-card"
            key={c.name}
            style={{ backgroundImage: `url(${c.img})` }}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.12, duration: 0.5 }}
          >
            <div className="coach-shade" />
            <div className="coach-body">
              <span>{c.tag}</span>
              <h3>{c.name}</h3>
              <p>{c.role}</p>
              <span className="coach-link">Book a session <SafeIcon icon={FiArrowUpRight} /></span>
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
export default Coaches;
